// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Image-module_imageWrapper__U2NKI","contain":"Image-module_contain__WN8Lb","image":"Image-module_image__oV5Od"};